module.exports = __webpack_public_path__ + "static/media/certs-active.bae2f9b1.png";